import { FaWindows, FaApple, FaLinux, FaAndroid } from "react-icons/fa";
import type { IconType } from "react-icons";
import { Monitor } from "lucide-react";

// Logos de marque OS (react-icons / Font Awesome Brands). Le `name` vient du
// heartbeat plugin : "Windows" | "MacOS" | "Linux" | "Android" | "iOS" |
// "Unknown". macOS et iOS partagent la pomme. Fallback Monitor (lucide).
const OS_ICONS: Record<string, IconType> = {
  Windows: FaWindows,
  MacOS: FaApple,
  macOS: FaApple,
  iOS: FaApple,
  Linux: FaLinux,
  Android: FaAndroid,
};

export function OsIcon({
  name,
  className = "h-4 w-4 shrink-0 text-muted-foreground",
}: {
  name?: string | null;
  className?: string;
}) {
  const Icon = (name ? OS_ICONS[name] : undefined) ?? Monitor;
  const label = name || "OS inconnu";
  return (
    <span className="inline-flex" role="img" aria-label={label} title={label}>
      <Icon className={className} aria-hidden />
    </span>
  );
}
